/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames as cx, propsUtils } from '@ba-ui-toolkit/utils';
import Checkbox from '@ba-ui-toolkit/checkbox';

import styles from './CheckboxGroup.scss';

const checkboxGroupClassName = styles.checkboxGroupClassName.replace(/"/g, '');
const { sanitize, getInheritedProps } = propsUtils;

export default class CheckboxGroup extends Component {
	static propTypes = {
		...Checkbox.propTypes,
		options: PropTypes.arrayOf(
			PropTypes.shape({
				label: PropTypes.string.isRequired,
				title: PropTypes.string,
			})
		).isRequired,
		selected: PropTypes.object,
		indeterminate: PropTypes.bool,
		tabIndex: PropTypes.number,
		align: PropTypes.oneOf(['left', 'right']),
		disabled: PropTypes.bool,
		readOnly: PropTypes.bool,
		hover: PropTypes.bool,
		active: PropTypes.bool,
		visual: PropTypes.bool,
		onClick: PropTypes.func,
		onChange: PropTypes.func.isRequired,
		direction: PropTypes.oneOf(['horizontal', 'vertical']),
		className: PropTypes.string,
		style: PropTypes.object,
	};

	static defaultProps = {
		align: 'left',
		direction: 'vertical',
		className: '',
		style: {},
	};

	_onChange(index) {
		this.props.onChange && this.props.onChange(this.props.options[index].label);
	}

	render() {
		const {
			options,
			align,
			direction,
			disabled,
			readOnly,
			hover,
			active,
			visual,
			onClick,
			selected,
			indeterminate,
			className,
			style,
			checkboxsExtraOptions,
			...others
		} = this.props;
		const classNames = cx(checkboxGroupClassName, direction, align);
		const checkboxPassthroughProps = getInheritedProps(others, Checkbox);

		return (
			<div
				{...sanitize(others, CheckboxGroup)}
				className={`${classNames} ${className}`}
				style={style}
			>
				{options.map(({ label, title }, index) => {
					const checkBoxProps = {
						...checkboxPassthroughProps,
						label,
						checked: selected && selected[label] && !indeterminate,
						indeterminate: selected && selected[label] && indeterminate,
						title,
						align,
						disabled,
						readOnly,
						visual,
						hover,
						active,
						onClick,
						onChange: this._onChange.bind(this, index),
						'aria-labelledby': label,
					};

					return (
						<div key={index} className={`${checkboxGroupClassName}__item`}>
							<Checkbox
								{...checkBoxProps}
								data-tid={`ba-common-checkbox-group__checkbox-${index}`}
							/>
						</div>
					);
				})}
			</div>
		);
	}
}
